import * as React from "react";
import { Button } from "./Button";
import { MetaDataIcon } from "../Icons/MetaDataIcon";
import { Strings } from "../Stores/StringsStore";

export class MetaDataInfoButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.infoButtonTooltip} >
			<MetaDataIcon />
		</Button>;
	}
}